<template>
    <div class="product-soluton">
        <section-title main="我们提供全套产品解决方案" sub="适用于各种规模的机构" class="section-title-box2"></section-title>
        <div class="content-box">
            <navProductList class="mainShow"  @productItemClicked="handleClickItem"> </navProductList>
        </div>

    </div>
</template>
<script>
import { productSolutionList } from '@/const'
import navProductList from '../../../production/components/navProductList.vue'
export default {
    data () {
        return {
            productSolutionList: productSolutionList,
            old:false
        }
    },
    components: { navProductList },
    methods: {
        handleClickItem (itemInfo) {
            if (itemInfo.redirectType === 'newPage') {
                window.open(itemInfo.redirectUrl)
            } else {
                this.goPath(itemInfo.redirectUrl)
            }
        },
        goPath (path) {
            this.$router.push(path)
        }
    }
}
</script>
<style lang="scss" scoped>
.product-soluton{
    background: linear-gradient(360deg, #6DA9FF 0%, #3B70FF 100%);
    .content-box{
        padding: 0px 20px;
        width: 100%;
        padding-bottom: 4px;
        /deep/.content-box {
            padding: 0px !important;
        }
        /deep/.main-list-item {
            background-color:rgba(255,255,255,0.8);
            border-radius: 14px;
            /*opacity: 0.8;*/
            margin-right:0px !important;
            padding-left:20px;
            margin-bottom: 20px;
            padding-bottom: 2px;
        }
        
    }
    .section-title-box2 {
        font-family: PingFangSC-Medium, PingFang SC;
        padding-top: 20px;
        /deep/.main {
            font-size: 18px;            
            font-weight: 500;
            color: #FFFFFF;
            line-height: 25px;
        }
        /deep/.sub {
            font-size: 10px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 14px;
        }
    }
}
</style>